export default __webpack_public_path__ + "static/media/access-image@3x.90d83329.jpg";